import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { TransformCta } from '../TransformCta';
export function Guarantee() {
  return <section className="bg-panel py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-196" data-mp="20m4te3jysz0a">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-197" data-mp="24mewn8gdhbbg">
        <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full border-4 border-ok bg-ok/10" data-id="element-198" data-mp="29doli6u3kama">
          <ShieldCheckIcon className="h-14 w-14 text-ok" aria-hidden="true" data-id="element-199" data-mp="2edt0ttj9qzax" />
        </div>
        <p className="mt-6 font-display text-lg font-bold uppercase tracking-[0.06em] text-ok" data-id="element-200" data-mp="2jbl1pd1w5vr9">Your purchase is protected</p>
        <h2 id="guarantee-title" className="mt-2 font-display text-[44px] font-extrabold uppercase leading-[0.95] text-white sm:text-6xl" data-id="element-201" data-mp="2ocijvpmwipsr">
          7-day money-back guarantee
        </h2>
        <div className="mt-6 space-y-3 text-lg leading-relaxed text-mist" data-id="element-202" data-mp="ty7ung2e9tmg">
          <p data-id="element-203" data-mp="xy8930phu4ti">
            We want you to feel confident about your purchase. That’s why HVAC Electrical Troubleshooting Blueprint™
            comes with a 7-day money-back guarantee.
          </p>
          <p data-id="element-204" data-mp="3nu6m4lwg4jpo">
            Explore the materials, review the troubleshooting workflows, and see whether the tools fit your professional
            needs. If the product isn’t right for you, request a refund within seven days of purchase under the
            guarantee.
          </p>
          <p className="font-semibold text-white" data-id="element-205" data-mp="fewmdkg13ql2">Your purchase is protected.</p>
        </div>

        <TransformCta label="Get instant access for $27" data-id="element-206" data-mp="aftul1p27gv1" />
      </div>
    </section>;
}